import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/extension-blocker.css'
import './utils/error-handler'
import { initErrorTracking } from './observability/error-tracking'

// Task #2604 — Error tracking (GlitchTip). No-op se VITE_ERROR_TRACKING_DSN vuoto.
initErrorTracking()

// Register the master service worker so push notifications can be received and
// gated (quiet hours, per-category push toggle) on the master origin. The SW
// file lives in public/sw.js; import.meta.env.BASE_URL resolves to '/master/'
// in the standard deployment or '/' on the dedicated master subdomain, so the
// registration path is always correct for both modes.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swPath = (import.meta.env.BASE_URL || '/').replace(/\/$/, '') + '/sw.js';
    navigator.serviceWorker.register(swPath)
      .catch((err) => {
        console.warn('[EasyFlow Master SW] Registration failed:', err);
      });
  });
}

if (typeof window !== 'undefined') {
  const savedTheme = localStorage.getItem('master-theme') || 'dark';
  if (savedTheme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)// rebuild Sun Oct 26 21:55:03 UTC 2025
